import { gql } from '@apollo/client';

const GET_IMAGES_QUERY = gql`
  query getImages($where: JSON!) {
    getImages: getFiles(where: $where) {
      id
      url
      data
    }
  }
`;

const PROPS_TO_CHECK = [
  'altText',
  'caption',
  'hrefUrl',
  'credits',
];

const IN_VIEW_CONFIG = {
    once: true,
    offset: '200px',
    bottomOffset: '-200px'
  };


export {
    GET_IMAGES_QUERY,
    IN_VIEW_CONFIG,
    PROPS_TO_CHECK
}